module.exports = __webpack_public_path__ + "images/edge-old-2.jpg?221d1c4f8b46558d77f5dc8a4e68a045";